import { render, staticRenderFns } from "./ListLicenses.vue?vue&type=template&id=68f65654&scoped=true"
import script from "./ListLicenses.vue?vue&type=script&lang=js"
export * from "./ListLicenses.vue?vue&type=script&lang=js"
import style0 from "./ListLicenses.vue?vue&type=style&index=0&id=68f65654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f65654",
  null
  
)

export default component.exports